/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Urgency_TitleInputs */

const en_home_urgency_title = /** @type {(inputs: Home_Urgency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WE NEED TO ACT <u>RIGHT NOW</u>`)
};

/**
* | output |
* | --- |
* | "WE NEED TO ACT <u>RIGHT NOW</u>" |
*
* @param {Home_Urgency_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_urgency_title = /** @type {((inputs?: Home_Urgency_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Urgency_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_urgency_title(inputs)
});